/* eslint-disable @typescript-eslint/no-unused-vars */
import { BreadcrumbLayout } from "@/components/breadcrumb/Breadcrumb";
import { DashboardButton } from "@/components/button/DashboardButton";
import {
	useGetAllPermissionsQuery,
	useGetRoleQuery,
	useUpdateRoleMutation,
} from "@/services/requests/dashboard";
import { editRoleInputTypes } from "@/types/formInputTypes";
import {
	Accordion,
	AccordionButton,
	AccordionIcon,
	AccordionItem,
	AccordionPanel,
	Box,
	Button,
	Checkbox,
	CheckboxGroup,
	Flex,
	HStack,
	SimpleGrid,
	Text,
	useToast,
} from "@chakra-ui/react";
import React, { useEffect, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router";

const EditRole = () => {
	const { role } = useParams();

	const router = useNavigate();
	const toast = useToast();

	const { reset, handleSubmit, control } = useForm<editRoleInputTypes>();

	const { data } = useGetAllPermissionsQuery();
	const { data: roles } = useGetRoleQuery(role || "");

	const [updateRole, { isLoading: isUpdating, isSuccess, isError, error }] =
		useUpdateRoleMutation();

	const result = useMemo(
		() => roles?.data[0]?.permissions?.map(({ name }) => name),
		[roles]
	);

	useEffect(() => {
		if (roles) {
			reset({
				permissions: result,
			});
		}
	}, [roles]);

	function onSubmit(submitData: editRoleInputTypes) {
		const updatedPermission: number[] = [];

		data?.data?.map((permission) =>
			submitData.permissions.map((name: string) => {
				if (name === permission.name) {
					updatedPermission.push(permission.id);
				}
			})
		);

		updateRole({
			permission: updatedPermission,
			id: roles?.data[0]?.id,
			role: roles?.data[0]?.role,
			createdBy: roles?.data[0]?.createdBy,
		});
	}

	useEffect(() => {
		if (isSuccess) {
			toast({
				title: "Role updated successfully",
				status: "success",
				duration: 9000,
				isClosable: true,
			});

			router("/dashboard/team/roles");
		}
	}, [isSuccess]);

	useEffect(() => {
		if (isError) {
			toast({
				title: "An error occurred",
				status: "error",
				duration: 9000,
				isClosable: true,
			});
		}
	}, [isError]);

	return (
		<Box as="form" onSubmit={handleSubmit(onSubmit)}>
			<Flex align="center" justify="space-between">
				<BreadcrumbLayout
					BreadcrumbLinkOne="Home"
					BreadcrumbLinkTwo="Roles"
					BreadcrumbLinkThree={roles?.data[0]?.role}
				/>

				<HStack>
					<Button
						onClick={() => router("/dashboard/team/roles")}
						bg="none"
						color="brand.gray100"
					>
						Cancel
					</Button>
					<DashboardButton
						type="submit"
						text={isUpdating ? "Loading..." : "SAVE CHANGES"}
					/>
				</HStack>
			</Flex>
			<Box
				w="100%"
				p="2rem"
				bg="brand.white100"
				border="1px solid #E4E4E4"
				borderRadius="5px"
				mt="2rem"
			>
				<Box w="100%" maxW="400px" m="0 auto">
					{/* <InputGroup label="Role" value="Admin-Product" /> */}
				</Box>

				<Box
					w="100%"
					maxW="400px"
					m="1rem auto"
					bg="brand.white300"
					borderRadius="5px"
					border="1px solid #E4E4E4"
					p="1.5rem 1.25rem"
				>
					<Accordion allowToggle>
						<AccordionItem>
							<h2>
								<AccordionButton>
									<Box flex="1" textAlign="left">
										Permissions
									</Box>
									<AccordionIcon />
								</AccordionButton>
							</h2>
							<AccordionPanel pb={4}>
								<HStack my="0.75rem" spacing={4}>
									<Text fontSize="xs">PERMISSIONS</Text>
									<Button
										onClick={() =>
											reset({
												permissions: data?.data?.map(({ name }) => name),
											})
										}
										color="brand.blue200"
										bg="none"
										size="sm"
									>
										Select All
									</Button>
									<Button
										onClick={() => reset({ permissions: [] })}
										color="brand.blue200"
										bg="none"
										size="sm"
									>
										Deselect All
									</Button>
								</HStack>

								<Controller
									name="permissions"
									control={control}
									render={({ field: { ref: _ref, ...field } }) => (
										<CheckboxGroup {...field}>
											<SimpleGrid mt="2rem" columns={2} gap="1rem">
												{data?.data.map((item, index) => (
													<Checkbox
														key={index}
														value={item?.name}
														name="permissions"
													>
														{item?.name}
													</Checkbox>
												))}
											</SimpleGrid>
										</CheckboxGroup>
									)}
								/>
							</AccordionPanel>
						</AccordionItem>
					</Accordion>
				</Box>
			</Box>
		</Box>
	);
};

export default EditRole;
